/**
 * Created by hcq on 2023/12/27.
 */
import { createRouter, createWebHashHistory } from "vue-router";
export const Layout = () => import("@/layout/index.vue");

const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "/",
    children: [
      {
        path: "/",
        name: "index",
        meta: {
          title: "智媒果-AIGC创作平台",
        },
        component: () => import("@/views/index/index.vue"),
      },
      {
        // 工作流详情页
        path: "/detail/:id",
        name: "detail",
        meta: {
          title: "智媒果-AIGC创作平台",
        },
        component: () => import("@/views/detail/index.vue"),
      },
      {
        path: "/history",
        name: "history",
        meta: {
          title: "生成历史-AIGC",
        },
        component: () => import("@/views/history/index.vue"),
      },
      {
        //创作广场
        path: "/square",
        name: "square",
        meta: {
          title: "创作广场-AIGC",
        },
        component: () => import("@/views/square/index.vue"),
      },
      {
        //文字创作
        path: "/chat",
        name: "chat",
        meta: {
          title: "AI 对话",
        },
        component: () => import("@/views/chat/index.vue"),
      },
      {
        //文字创作
        path: "/storyBoardChat",
        name: "storyBoardChat",
        meta: {
          title: "AI 导演",
        },
        component: () => import("@/views/storyBoardChat/index.vue"),
      },
      {
        //视频创作
        path: "/video",
        name: "video",
        meta: {
          title: "AI 视频",
        },
        component: () => import("@/views/video/index.vue"),
      },
      {
        //特效工厂
        path: "/effect",
        name: "effect",
        meta: {
          title: "特效工厂",
        },
        component: () => import("@/views/effect/index.vue"),
      },
     
			{
				//短片
				path: "/shortVideo",
				name: "shortVideo",
				meta: {
					title: "AI 短片",
				},
				component: () => import("@/views/shortVideo/index.vue"),
			},
      {
        //图像创作
        path: "/image",
        name: "image",
        meta: {
          title: "AI 图像",
        },
        component: () => import("@/views/image/index.vue"),
      },
      {
        //图像创作（重构版 - 开发中）
        path: "/imageNew",
        name: "imageNew",
        meta: {
          title: "AI 图像",
        },
        component: () => import("@/views/imageNew/index.vue"),
      },
      {
        //无限画布
        path: "/canvasWorkflow",
        name: "canvasWorkflow",
        meta: {
          title: "无限画布",
        },
        component: () => import("@/views/canvasWorkflow/index.vue"),
      },
      {
        //图像创作
        path: "/darkroom",
        name: "darkroom",
        meta: {
          title: "AI 暗房",
        },
        component: () => import("@/views/darkroom/index.vue"),
      },
      {
        //常见问题
        path: "/question",
        name: "question",
        meta: {
          title: "常见问题-AIGC",
        },
        component: () => import("@/views/question/index.vue"),
      },
      {
        //音乐
        path: "/music",
        name: "music",
        meta: {
          title: "AI 音乐",
        },
        component: () => import("@/views/music/index.vue"),
      },
      {
        //音频
        path: "/voice",
        name: "voice",
        meta: {
          title: "AI 配音",
        },
        component: () => import("@/views/voiceLaboratory/voiceIndex.vue"),
      },
      {
        //音频
        path: "/recordingStudio",
        name: "recordingStudio",
        meta: {
          title: "AI 录音棚",
        },
        component: () => import("@/views/voiceLaboratory/voiceIndex.vue"),
      },
      {
      	//写稿
      	path: "/writing",
      	name: "writing",
      	meta: {
      	  title: "AI 写稿",
      	},
      	component: () => import("@/views/masterStrokeInner/index.vue"),
      },
      {
        //数字人
        path: "/dgitalMan",
        name: "dgitalMan",
        meta: {
          title: "AI 数字人",
        },
        component: () => import("@/views/dgitalMan/index.vue"),
      },
      {
        //AI影棚
        path: "/studio",
        name: "studio",
        meta: {
          title: "AI 影棚",
        },
        component: () => import("@/views/studio/index.vue"),
      },
      {
        //数字人
        path: "/personHistory",
        name: "personHistory",
        meta: {
          title: "数字人",
        },
        component: () => import("@/views/dgitalMan/personHistory.vue"),
      },
      {
        //搜索
        path: "/model/search/result",
        name: "result",
        meta: {
          title: "搜索-AIGC",
        },
        component: () => import("@/views/result/index.vue"),
      },
      {
        //海报
        path: "/poster",
        name: "poster",
        meta: {
          title: "AI 海报",
        },
        component: () => import("@/views/poster/index.vue"),
      },
      {
        //AI活动案例
        path: "/application",
        name: "application",
        meta: {
          title: "AI 活动案例",
        },
        component: () => import("@/views/application/index.vue"),
      },
      {
        //MJ绘画
        path: "/mjdraw",
        name: "mjdraw",
        meta: {
          title: "MJ绘画",
        },
        component: () => import("@/views/mjdraw/index.vue"),
      },
      {
        //搜索
        path: "/aitools",
        name: "aitools",
        meta: {
          title: "AI 工具",
        },
        component: () => import("@/views/aiTools/index.vue"),
      },
      {
        // 工作流详情页，必须传递 id 参数
        path: "/aiDetail/:id/:channelId",
        name: "aiDetail",
        meta: {
          title: "智媒果-AIGC创作平台",
          requiresId: true, // 自定义 meta 属性，用来表示必须传 id
        },
        component: () => import("@/views/aiTools/aiDetail.vue"),
        beforeEnter: (to: any, from: any, next: any) => {
          // 检查是否有 id 参数
          if (to.params.id && to.params.channelId) {
            next(); // 如果有 id 参数，允许进入路由
          } else {
            next("/aitools"); // 如果没有 id 参数，重定向到主页或其他页面
          }
        },
      },
      {
        //搜索
        path: "/aiTeacher",
        name: "aiTeacher",
        meta: {
          title: "AI 教程",
        },
        component: () => import("@/views/aiTools/aiTeacher.vue"),
      },
      {
        //User Agreement and Privacy

        path: "/userAgreement",
        name: "userAgreement",
        meta: {
          title: "用户协议与隐私",
        },
        component: () => import("@/views/userAgreement/index.vue"),
      },
    ],
  },
  {
    //写作平台
    path: "/masterStroke",
    name: "masterStroke",
    meta: {
      title: "智媒果写作",
    },
    component: () => import("@/views/masterStroke/index.vue"),
  },
  {
    //历史记录
    path: "/masterStroke/history",
    name: "masterStrokeHistory",
    meta: {
      title: "智媒果写作",
    },
    component: () => import("@/views/masterStroke/header.vue"),
  },
  {
    //智媒果算力开放平台（独立页面）
    path: "/computingPlatform",
    name: "computingPlatform",
    meta: {
      title: "智媒果算力开放平台",
    },
    component: () => import("@/views/computingPlatform/index.vue"),
    redirect: "/computingPlatform/modelSquare",
    children: [
      {
        path: "modelSquare",
        name: "cpModelSquare",
        meta: {
          title: "智媒果算力开放平台",
        },
        component: () => import("@/views/computingPlatform/pages/modelSquare.vue"),
      },
      {
        path: "apiKey",
        name: "cpApiKey",
        meta: {
          title: "智媒果算力开放平台",
        },
        component: () => import("@/views/computingPlatform/pages/apiKey.vue"),
      },
      {
        path: "apiDoc",
        name: "cpApiDoc",
        meta: {
          title: "智媒果算力开放平台",
        },
        component: () => import("@/views/computingPlatform/pages/apiDoc.vue"),
      },
      {
        path: "dataCenter",
        name: "cpDataCenter",
        meta: {
          title: "智媒果算力开放平台",
        },
        component: () => import("@/views/computingPlatform/pages/dataCenter.vue"),
      },
    ],
  },
  {
    //智媒果短剧AI（独立页面）
    path: "/shortDramaAi",
    name: "shortDramaAi",
    meta: {
      title: "智媒果短剧AI",
    },
    component: () => import("@/views/shortDramaAi/index.vue"),
    redirect: "/shortDramaAi/projects",
    children: [
      {
        path: "projects",
        name: "shortDramaProjects",
        meta: {
          title: "智媒果短剧AI",
        },
        component: () => import("@/views/shortDramaAi/pages/project.vue"),
      },
      {
        path: "assets",
        name: "shortDramaAssets",
        meta: {
          title: "智媒果短剧AI",
        },
        component: () => import("@/views/shortDramaAi/pages/assets.vue"),
      },
    ],
  },
  {
    //智媒果短剧AI详情页（独立页面，无侧边栏）
    path: "/shortDramaAi/projectDetail/:id",
    name: "shortDramaDetail",
    meta: {
      title: "短剧项目详情",
    },
    component: () => import("@/views/shortDramaAi/projectDetail/index.vue"),
  },
  {
    //智媒果短剧AI剧集详情页（独立页面）
    path: "/shortDramaAi/episode/:episodeId",
    name: "shortDramaEpisodeDetail",
    meta: {
      title: "短剧剧集详情",
    },
    component: () => import("@/views/shortDramaAi/episodeDetail/index.vue"),
  },
  {
    // 智媒果移动端首页
    path: "/mobile",
    name: "mobile",
    meta: {
      title: "智媒果创作平台",
    },
    component: () => import("@/views/mobile/index.vue"),
  },
  {
    path: "/mobile/chat",
    name: "mobileChat",
    meta: { title: "AI 对话" },
    component: () => import("@/views/mobile/pages/chat.vue"),
  },
  {
    path: "/mobile/image",
    name: "mobileImage",
    meta: { title: "AI 图像" },
    component: () => import("@/views/mobile/pages/image.vue"),
  },
  {
    path: "/mobile/video",
    name: "mobileVideo",
    meta: { title: "AI 视频" },
    component: () => import("@/views/mobile/pages/video.vue"),
  },
  {
    path: "/mobile/music",
    name: "mobileMusic",
    meta: { title: "AI 音乐" },
    component: () => import("@/views/mobile/pages/music.vue"),
  },
  {
    path: "/mobile/login",
    name: "mobileLogin",
    meta: { title: "登录注册" },
    component: () => import("@/views/mobile/pages/login.vue"),
  },
  {
    path: "/mobile/agreement",
    name: "mobileAgreement",
    meta: { title: "用户协议与隐私" },
    component: () => import("@/views/mobile/pages/agreement.vue"),
  },
  {
    path: "/mobile/history",
    name: "mobileHistory",
    meta: { title: "生成历史" },
    component: () => import("@/views/mobile/pages/history.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes,
});

export const isMobile = () => {
  const ua = navigator.userAgent;
  if (/WindowsWechat|MacWechat/i.test(ua)) return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|MQQBrowser|UCBrowser|HuaweiBrowser|SamsungBrowser|XiaoMi|OPPO|vivo/i.test(ua);
};

router.beforeEach((to, from, next) => {
  if (isMobile()) {
    if (!to.path.startsWith("/mobile")) {
      next("/mobile");
      return;
    }
  } else {
    if (to.path.startsWith("/mobile")) {
      next("/");
      return;
    }
  }
  next();
});

router.afterEach((to, from, failure) => {
  if (failure) return;
  if (to?.meta?.title) {
    document.title = to.meta.title as string;
  }
});

export default router;
